/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================== Moss ======================== */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = "basic";
var klevu_layoutView = "grid";

klevu({
    theme: {
        setHelpers: {
            all: {
                setKlevuQuickPopupTopPositionVariable: function () {
                    klevu.each(
                        klevu.dom.find(".klevuWrap"),
                        function (key, currentElement) {
                            const topPosition = currentElement.getBoundingClientRect().top;
                            document.documentElement.style.setProperty(
                                "--klevuQuickPopupTopPosition",
                                `${topPosition}px`
                            );
                        }
                    );
                }
            },
        },
    },
});

klevu.beforeActivation("quick", function (data, scope) {
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTemplateTabResultsCustom, "klevuQuickTemplateTabResults", true);
        box.getScope().template.setTemplate(klevuQuickTemplateFiltersCustom, 'klevuQuickTemplateFilters', true);
    });
});

klevu.modifyRequest("quick", function (data, scope) {
    klevu.each(data.request.current.recordQueries, function (key, query) {
        // No results limit
        const queryID = klevu.getObjectPath(query, "id");
        if (queryID === 'noResultsFoundPopularProductList') {
            klevu.setObjectPath(query, "settings.limit", 8);
        }
        // No results limit END
    });
});

// --- GTM TRACKING: select_item (delegated) ---
// Cache: queryId -> Array of product records. Updated on every render/response.
// The delegated listener on document resolves the product from cache at click time,
// so it works for trending/recently-viewed products rendered on popup open (no search).
var _klevuResultsCache = {};
var _klevuViewItemListTimer = null;
var _klevuLastFiredSearchTerm = null;
var _klevuLastFiredOffset = -1;
var _klevuPopupOpen = false;
var _klevuVisibilityBuffer = {};
var _klevuActiveObservers = [];
var _klevuLastPageViewSearchTerm = null;
var _klevuSentItems = {};
/**
 * Updates the results cache for all queries present in a Klevu query map.
 * @param {Object} queryMap - data.template.query object from Klevu hooks
 */
function updateKlevuResultsCache(queryMap) {
    klevu.each(queryMap, function(queryId, queryData) {
        if (!queryData || !queryData.result || !Array.isArray(queryData.result)) return;
        if (queryData.result.length === 0) return;
        
        var currentOffset = 0;
        if (queryData.meta && queryData.meta.offset) {
            currentOffset = parseInt(queryData.meta.offset, 10) || 0;
        }
        
        _klevuResultsCache[queryId] = {
            result: queryData.result,
            offset: currentOffset
        };
    });
}

/**
 * Resolves a clicked product URL against the full cache (all queryIds).
 * Returns { record, queryId, index } or null.
 * @param {string} clickedUrl
 * @param {HTMLElement} [link] - Optional link element to infer query context from DOM
 */
function resolveKlevuRecord(clickedUrl, link) {
    var queryIds = Object.keys(_klevuResultsCache);
    
    if (link) {
        var specificQueryId = null;
        for (var q = 0; q < queryIds.length; q++) {
            var qId = queryIds[q];
            if (link.closest('[id*="' + qId + '"], [class*="' + qId + '"], [data-section="' + qId + '"]')) {
                specificQueryId = qId;
                break;
            }
        }
        if (specificQueryId) {
            queryIds = [specificQueryId].concat(queryIds.filter(function(id) { return id !== specificQueryId; }));
        } else {
            queryIds.sort(function(a, b) {
                if (a === 'productList') return -1;
                if (b === 'productList') return 1;
                return 0;
            });
        }
    }

    for (var q = 0; q < queryIds.length; q++) {
        var queryId = queryIds[q];
        var cacheData = _klevuResultsCache[queryId];
        if (!cacheData) continue;
        
        var resultArray = cacheData.result || [];
        var offset = cacheData.offset || 0;
        
        for (var i = 0; i < resultArray.length; i++) {
            var recordUrl = resultArray[i].url;
            if (recordUrl && (clickedUrl.indexOf(recordUrl) > -1 || recordUrl.indexOf(clickedUrl) > -1)) {
                return { record: resultArray[i], queryId: queryId, index: offset + i + 1 };
            }
        }
    }
    return null;
}

function buildKlevuItemsFromQuery(queryData, listOffset, listId, listName) {
    var items = [];
    if (!queryData || !queryData.result || !Array.isArray(queryData.result)) return items;
    listOffset = listOffset || 0;
    listId = listId || 'search';
    listName = listName || 'search';
    
    for (var i = 0; i < queryData.result.length; i++) {
        var record = queryData.result[i];
        var handle = '';
        var urlParts = record.url ? record.url.split('/products/') : [];
        if (urlParts.length > 1) {
            handle = urlParts[1].split('?')[0];
        }
        var isBundle = false;
        var klevuTags = record.tags || [];
        if (typeof klevuTags === 'string') {
            klevuTags = klevuTags.split(',');
        }
        for (var t = 0; t < klevuTags.length; t++) {
            if (klevuTags[t].trim().toLowerCase() === 'bundle') {
                isBundle = true;
                break;
            }
        }
        
        var shopifyProductId = record.itemGroupId || (record.id ? record.id.split('_')[0] : '');
        var finalItemId = '';
        if (isBundle && shopifyProductId) {
            finalItemId = ('bundle_' + shopifyProductId).toLowerCase();
        } else {
            finalItemId = record.sku ? record.sku.toLowerCase().substring(0, 9) : '';
        }

        var klevuPrice = parseFloat(record.price) || 0;
        var klevuSalePrice = parseFloat(record.salePrice) || klevuPrice;
        var finalPrice = klevuSalePrice;
        var discount = klevuPrice - finalPrice;
        
        items.push({
            itemId: finalItemId,
            itemName: handle || record.name,
            price: finalPrice,
            discount: discount > 0 ? discount : 0,
            itemListName: listName,
            itemListId: listId,
            sizesWithoutStock: undefined,
            index: listOffset + i + 1,
            vendor: record.brand ? record.brand.toLowerCase() : '',
            product_type: undefined
        });
    }
    return items;
}

function pushKlevuPageView(searchTerm, totalResults) {
    if (!window.BoboDataLayer || typeof window.BoboDataLayer.push !== 'function') return;
    if (!window.BoboDatalayerHelpers) return;
    // Avoid re-sending page_view on pagination (same term, different offset)
    if (searchTerm === _klevuLastPageViewSearchTerm) {
        if (localStorage.getItem('bobo_gtm_debug') === 'true') {
            console.log('[GTM Debug] Klevu page_view skipped (pagination): same searchTerm "' + searchTerm + '"');
        }
        return;
    }
    _klevuLastPageViewSearchTerm = searchTerm;
    window.BoboDataLayer.push('page_view', {
        genericUrl: "/search",
        urlParams: window.BoboDatalayerHelpers.getParamsUrl(),
        filterSortContext: {
            filterSize: undefined,
            filterColor: undefined,
            filterMaterial: undefined,
            filterQuickFilter: undefined,
            sort: undefined
        },
        searchContext: {
            searchTerm: searchTerm,
            searchResults: totalResults
        }
    });
    if (localStorage.getItem('bobo_gtm_debug') === 'true') {
        console.log('[GTM Debug] Klevu page_view pushed for searchTerm: "' + searchTerm + '" (' + totalResults + ' results)');
    }
}

function buildItemFromKlevuRecord(record, index, listId, listName) {
    var handle = '';
    var urlParts = record.url ? record.url.split('/products/') : [];
    if (urlParts.length > 1) handle = urlParts[1].split('?')[0];

    var isBundle = false;
    var klevuTags = record.tags || [];
    if (typeof klevuTags === 'string') klevuTags = klevuTags.split(',');
    for (var t = 0; t < klevuTags.length; t++) {
        if (klevuTags[t].trim().toLowerCase() === 'bundle') { isBundle = true; break; }
    }

    var shopifyProductId = record.itemGroupId || (record.id ? record.id.split('_')[0] : '');
    var finalItemId = (isBundle && shopifyProductId)
        ? ('bundle_' + shopifyProductId).toLowerCase()
        : (record.sku ? record.sku.toLowerCase().substring(0, 9) : '');

    var klevuPrice = parseFloat(record.price) || 0;
    var klevuSalePrice = parseFloat(record.salePrice) || klevuPrice;
    var discount = klevuPrice - klevuSalePrice;

    return {
        itemId: finalItemId,
        itemName: handle || record.name,
        price: klevuSalePrice,
        discount: discount > 0 ? discount : 0,
        itemListName: listName,
        itemListId: listId,
        sizesWithoutStock: undefined,
        index: index,
        vendor: record.brand ? record.brand.toLowerCase() : '',
        product_type: undefined
    };
}

function updateKlevuSessionStorage() {
    var allPendingItems = [];
    Object.keys(_klevuVisibilityBuffer).forEach(function(listId) {
        allPendingItems = allPendingItems.concat(_klevuVisibilityBuffer[listId].items);
    });
    if (allPendingItems.length === 0) {
        sessionStorage.removeItem('bobo_gtm_pending_klevu_view_item_list');
    } else {
        sessionStorage.setItem('bobo_gtm_pending_klevu_view_item_list', JSON.stringify(allPendingItems));
    }
}

function flushKlevuBuffer(listId, reason, forceAll) {
    var bufferEntry = _klevuVisibilityBuffer[listId];
    if (!bufferEntry || bufferEntry.items.length === 0) return;

    var debugEnabled = localStorage.getItem('bobo_gtm_debug') === 'true';
    var batchSize = (typeof window._klevuGtmBatchSize !== 'undefined') ? window._klevuGtmBatchSize : 6;

    function sendBatch(itemsToSend) {
        if (window.BoboDataLayer && typeof window.BoboDataLayer.pushEcommerce === 'function') {
            if (debugEnabled) {
                console.log('[GTM Debug] Klevu buffer flush (' + reason + '): view_item_list "' + listId + '" → ' + itemsToSend.length + ' items');
            }
            window.BoboDataLayer.pushEcommerce('view_item_list', {
                item_list_id: listId,
                item_list_name: bufferEntry.listName,
                items: itemsToSend
            });
            if (!_klevuSentItems[listId]) {
                _klevuSentItems[listId] = {};
            }
            itemsToSend.forEach(function(item) {
                _klevuSentItems[listId][item.itemId] = true;
            });
        }
    }

    if (forceAll) {
        var itemsToSend = bufferEntry.items.splice(0, bufferEntry.items.length);
        sendBatch(itemsToSend);
    } else {
        while (bufferEntry.items.length >= batchSize) {
            var itemsToSend = bufferEntry.items.splice(0, batchSize);
            sendBatch(itemsToSend);
        }
    }
    updateKlevuSessionStorage();
}

function flushAllKlevuBuffers(reason) {
    Object.keys(_klevuVisibilityBuffer).forEach(function(listId) {
        flushKlevuBuffer(listId, reason, true);
    });
    _klevuVisibilityBuffer = {};
}

function setupKlevuProductsObserver(config) {
    var debugEnabled = localStorage.getItem('bobo_gtm_debug') === 'true';
    var containerEl   = config.containerEl;
    var itemSelector  = config.itemSelector;
    var rootSelector  = config.rootSelector || null;
    var listId        = config.listId;
    var listName      = config.listName;
    var threshold     = config.threshold !== undefined ? config.threshold : 0.5;
    var debounceMs    = config.debounceMs !== undefined ? config.debounceMs : 200;

    if (!containerEl) {
        if (debugEnabled) console.warn('[GTM Debug] Klevu observer: containerEl not found for ' + listId);
        return false;
    }

    var rootEl = null;
    if (rootSelector) {
        rootEl = containerEl.querySelector(rootSelector);
        if (!rootEl) {
            if (debugEnabled) console.warn('[GTM Debug] Klevu observer: root not found (' + rootSelector + ') for ' + listId);
            return false;
        }
    }

    var items = containerEl.querySelectorAll(itemSelector);
    if (items.length === 0) {
        if (debugEnabled) console.warn('[GTM Debug] Klevu observer: no items found (' + itemSelector + ') for ' + listId);
        return false;
    }

    if (!_klevuVisibilityBuffer[listId]) {
        _klevuVisibilityBuffer[listId] = { items: [], listName: listName };
    }

    var observedUrls = {};
    if (_klevuSentItems[listId]) {
        Object.keys(_klevuSentItems[listId]).forEach(function(itemId) {
            observedUrls[itemId] = true;
        });
    }
    if (_klevuVisibilityBuffer[listId] && _klevuVisibilityBuffer[listId].items) {
        _klevuVisibilityBuffer[listId].items.forEach(function(item) {
            observedUrls[item.itemId] = true;
        });
    }

    var initialFlushTimer = null;
    var isInitialRender = true;

    // Shared logic: process an item element that is considered visible
    function processVisibleItem(itemEl) {
        var link = itemEl.querySelector('a[href*="/products/"]');
        if (!link) return false;

        var href = link.getAttribute('href');
        if (!href) return false;

        var resolved = resolveKlevuRecord(href, link);
        if (!resolved) return false;

        var gtmItem = buildItemFromKlevuRecord(resolved.record, resolved.index, listId, listName);
        if (observedUrls[gtmItem.itemId]) return false;

        if (debugEnabled) {
            console.log('[GTM Debug] Klevu item intersected:', gtmItem.itemName, '(Index: ' + gtmItem.index + ')');
        }

        _klevuVisibilityBuffer[listId].items.push(gtmItem);
        observedUrls[gtmItem.itemId] = true;
        return true;
    }

    var observer = new IntersectionObserver(function(entries) {
        var addedAny = false;

        entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            if (processVisibleItem(entry.target)) {
                observer.unobserve(entry.target);
                addedAny = true;
            }
        });

        if (!addedAny) return;

        updateKlevuSessionStorage();

        if (isInitialRender) {
            if (initialFlushTimer) clearTimeout(initialFlushTimer);
            initialFlushTimer = setTimeout(function() {
                flushKlevuBuffer(listId, 'Initial render', false);
                isInitialRender = false;
            }, debounceMs);
        } else {
            flushKlevuBuffer(listId, 'Scroll / carousel nav', false);
        }
    }, {
        root: rootEl,
        threshold: threshold
    });

    items.forEach(function(item) { observer.observe(item); });
    _klevuActiveObservers.push(observer);

    // For Klevu carousels: the navigation uses JS-driven absolute positioning (style.left),
    // not native CSS scroll, so IntersectionObserver does not fire on arrow clicks.
    // We add manual visibility checks on nav arrow clicks as a complement.
    if (rootEl) {
        var navButtons = containerEl.querySelectorAll('.nav.nav-left, .nav.nav-right');
        if (navButtons.length > 0) {
            var carouselNavTimer = null;
            navButtons.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    // Wait for Klevu's JS animation to finish updating slide positions
                    if (carouselNavTimer) clearTimeout(carouselNavTimer);
                    carouselNavTimer = setTimeout(function() {
                        var rootRect = rootEl.getBoundingClientRect();
                        var addedByNav = false;

                        items.forEach(function(itemEl) {
                            var itemRect = itemEl.getBoundingClientRect();
                            // Check overlap: item must have >= threshold fraction visible within rootEl bounds
                            var overlapLeft   = Math.max(itemRect.left, rootRect.left);
                            var overlapRight  = Math.min(itemRect.right, rootRect.right);
                            var visibleWidth  = overlapRight - overlapLeft;
                            var visibleRatio  = visibleWidth / itemRect.width;

                            if (visibleRatio >= threshold && processVisibleItem(itemEl)) {
                                observer.unobserve(itemEl);
                                addedByNav = true;
                            }
                        });

                        if (addedByNav) {
                            if (debugEnabled) {
                                console.log('[GTM Debug] Klevu carousel nav: new items visible for ' + listId);
                            }
                            updateKlevuSessionStorage();
                            flushKlevuBuffer(listId, 'Carousel nav click', false);
                        }
                    }, 350);
                });
            });
            if (debugEnabled) {
                console.log('[GTM Debug] Klevu carousel nav listeners attached for ' + listId + ' (' + navButtons.length + ' buttons)');
            }
        }
    }

    if (debugEnabled) {
        console.log('[GTM Debug] Klevu observer setup: ' + listId + ' (' + items.length + ' items, root: ' + (rootSelector || 'viewport') + ')');
    }
    return true;
}

function flushKlevuViewItemList(queryMap, searchTerm, isPopupOpen) {
    var debugEnabled = localStorage.getItem('bobo_gtm_debug') === 'true';
    
    // Always disconnect old observers when we re-setup observers
    _klevuActiveObservers.forEach(function(obs) { obs.disconnect(); });
    _klevuActiveObservers = [];

    if (searchTerm) {
        flushAllKlevuBuffers('New search / pagination: ' + searchTerm);

        var minLen = (typeof window._klevuGtmMinQueryLength !== 'undefined') ? window._klevuGtmMinQueryLength : 3;
        if (searchTerm.length < minLen) {
            if (debugEnabled) {
                console.log('[GTM Debug] Klevu view_item_list ignored: search term length (' + searchTerm.length + ') is less than min length (' + minLen + ')');
            }
            return;
        }
        var currentOffset = 0;
        if (queryMap['productList'] && queryMap['productList'].meta) {            
            currentOffset = parseInt(queryMap['productList'].meta.offset, 10) || 0;
        }

        if (searchTerm === _klevuLastFiredSearchTerm && currentOffset === _klevuLastFiredOffset) {
            if (debugEnabled) {
                console.log('[GTM Debug] Klevu view_item_list ignored: same term "' + searchTerm + '" and same offset (' + currentOffset + ')');
            }
            return;
        }
        
        var totalResults = (queryMap['productList'] && queryMap['productList'].meta)
            ? (parseInt(queryMap['productList'].meta.totalResultsFound, 10) || 0)
            : 0;

        var queryData = queryMap['productList'];
        var items = buildKlevuItemsFromQuery(queryData, currentOffset, 'search', 'search');

        _klevuLastFiredSearchTerm = searchTerm;
        _klevuLastFiredOffset = currentOffset;

        pushKlevuPageView(searchTerm, totalResults);

        if (items.length === 0) {
            if (debugEnabled) {
                console.log('[GTM Debug] Klevu view_item_list ignored: no results for search term "' + searchTerm + '"');
            }
            return;
        }

        var productListContainer = document.getElementById('productList');
        var usedObserver = setupKlevuProductsObserver({
            containerEl:  productListContainer,
            itemSelector: 'li.klevuProduct',
            rootSelector: null,
            listId:       'search',
            listName:     'search',
            threshold:    0.5,
            debounceMs:   150
        });

        if (!usedObserver) {
            if (window.BoboDataLayer && typeof window.BoboDataLayer.pushEcommerce === 'function') {
                if (debugEnabled) {
                    console.log('[GTM Debug] Klevu view_item_list pushed for search term "' + searchTerm + '" with ' + items.length + ' items:', items);
                }
                window.BoboDataLayer.pushEcommerce('view_item_list', { item_list_id: 'search', item_list_name: 'search', items: items });
            }
        }
    } else if (isPopupOpen && ((typeof window._klevuGtmTrackRecentView !== 'undefined') ? window._klevuGtmTrackRecentView : true)) {
        var firedAny = false;

        // Trending Products
        var trendingData = queryMap['trendingProductList'];
        var trendingContainer = document.getElementById('trendingProductList');
        var trendingUsedObserver = false;
        if (trendingContainer) {
            trendingUsedObserver = setupKlevuProductsObserver({
                containerEl:  trendingContainer,
                itemSelector: '.klevuProduct.kuSlide',
                rootSelector: '.kuCarousel',
                listId:       'search_trending_products',
                listName:     'search_trending_products',
                threshold:    0.5,
                debounceMs:   200
            });
            firedAny = true;
        }
        if (!trendingUsedObserver && trendingData && trendingData.result && trendingData.result.length > 0) {
            var trendingItems = buildKlevuItemsFromQuery(trendingData, 0, 'search_trending_products', 'search_trending_products');
            if (trendingItems.length > 0) {
                if (window.BoboDataLayer && typeof window.BoboDataLayer.pushEcommerce === 'function') {
                    if (debugEnabled) {
                        console.log('[GTM Debug] Klevu view_item_list pushed for Trending Products with ' + trendingItems.length + ' items:', trendingItems);
                    }
                    window.BoboDataLayer.pushEcommerce('view_item_list', { item_list_id: 'search_trending_products', item_list_name: 'search_trending_products', items: trendingItems });
                }
                firedAny = true;
            }
        }

        // Recent Viewed
        var recentData = queryMap['recentViewedProductList'];
        var recentContainer = document.getElementById('recentViewedProductList');
        var recentUsedObserver = false;
        if (recentContainer) {
            recentUsedObserver = setupKlevuProductsObserver({
                containerEl:  recentContainer,
                itemSelector: '.klevuProduct.kuSlide',
                rootSelector: '.kuCarousel',
                listId:       'search_recently_viewed',
                listName:     'search_recently_viewed',
                threshold:    0.5,
                debounceMs:   200
            });
            firedAny = true;
        }
        if (!recentUsedObserver && recentData && recentData.result && recentData.result.length > 0) {
            var recentItems = buildKlevuItemsFromQuery(recentData, 0, 'search_recently_viewed', 'search_recently_viewed');
            if (recentItems.length > 0) {
                if (window.BoboDataLayer && typeof window.BoboDataLayer.pushEcommerce === 'function') {
                    if (debugEnabled) {
                        console.log('[GTM Debug] Klevu view_item_list pushed for Recently Viewed with ' + recentItems.length + ' items:', recentItems);
                    }
                    window.BoboDataLayer.pushEcommerce('view_item_list', { item_list_id: 'search_recently_viewed', item_list_name: 'search_recently_viewed', items: recentItems });
                }
                firedAny = true;
            }
        }

        if (firedAny) {
            _klevuLastFiredSearchTerm = 'initialView';
            _klevuLastFiredOffset = 0;
        }
    }
}

function scheduleKlevuViewItemList(queryMap, searchTerm) {
    if (_klevuViewItemListTimer) {
        clearTimeout(_klevuViewItemListTimer);
    }
    
    var debounceMs = (typeof window._klevuGtmDebounceMs !== 'undefined') ? window._klevuGtmDebounceMs : 1500;
    var debugEnabled = localStorage.getItem('bobo_gtm_debug') === 'true';
    
    if (searchTerm) {
        if (debugEnabled) {
            console.log('[GTM Debug] Klevu view_item_list scheduled (searchTerm: "' + searchTerm + '", debounce: ' + debounceMs + 'ms)');
        }
        _klevuViewItemListTimer = setTimeout(function() {
            flushKlevuViewItemList(queryMap, searchTerm, true);
        }, debounceMs);
    } else {
        if (debugEnabled) {
            console.log('[GTM Debug] Klevu view_item_list scheduled (recentViewed, delay: 300ms)');
        }
        _klevuViewItemListTimer = setTimeout(function() {
            flushKlevuViewItemList(queryMap, '', true);
        }, 300);
    }
}

function cancelKlevuPendingTimer() {
    if (_klevuViewItemListTimer) {
        clearTimeout(_klevuViewItemListTimer);
        _klevuViewItemListTimer = null;
        if (localStorage.getItem('bobo_gtm_debug') === 'true') {
            console.log('[GTM Debug] Klevu pending view_item_list timer cancelled. Popup closed.');
        }
    }

    flushAllKlevuBuffers('Popup closed');
    _klevuActiveObservers.forEach(function(obs) { obs.disconnect(); });
    _klevuActiveObservers = [];

    _klevuPopupOpen = false;
    _klevuLastFiredSearchTerm = null;
    _klevuLastFiredOffset = -1;
    _klevuLastPageViewSearchTerm = null;
    _klevuSentItems = {};
}

(function setupKlevuPopupCloseDetection() {
    document.addEventListener('click', function(e) {
        if (_klevuPopupOpen && !e.target.closest('.klevuWrap') && !e.target.closest('.kuContainer') && !e.target.closest('.klevuSearchInput') && !e.target.closest('.kuTab')) {
            cancelKlevuPendingTimer();
        }
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && _klevuPopupOpen) {
            cancelKlevuPendingTimer();
        }
    });
})();

// Single delegated listener — set up once at script load time.
// Captures clicks on any product link inside the Klevu popup.
(function setupKlevuSelectItemDelegation() {
    document.addEventListener('click', function(e) {
        var link = e.target.closest('a[href*="/products/"]');
        if (!link) return;

        // Only act on links inside the Klevu popup
        if (!link.closest('.klevuWrap') && !link.closest('.kuContainer')) return;

        var clickedUrl = link.getAttribute('href');
        if (!clickedUrl) return;

        var resolved = resolveKlevuRecord(clickedUrl, link);
        if (!resolved) {
            return;
        }

        var clickedRecord = resolved.record;
        var queryId = resolved.queryId;
        var clickedIndex = resolved.index;

        // Extract handle from product URL
        var handle = '';
        var urlParts = clickedRecord.url.split('/products/');
        if (urlParts.length > 1) {
            handle = urlParts[1].split('?')[0];
        }

        var listId = 'search';
        var listName = 'search';
        if (queryId === 'trendingProductList') {
            listId = 'search_trending_products';
            listName = 'search_trending_products';
        } else if (queryId === 'recentViewedProductList') {
            listId = 'search_recently_viewed';
            listName = 'search_recently_viewed';
        }

        var isBundle = false;
        var klevuTags = clickedRecord.tags || [];
        if (typeof klevuTags === 'string') {
            klevuTags = klevuTags.split(',');
        }
        for (var t = 0; t < klevuTags.length; t++) {
            if (klevuTags[t].trim().toLowerCase() === 'bundle') {
                isBundle = true;
                break;
            }
        }
        
        var shopifyProductId = clickedRecord.itemGroupId || (clickedRecord.id ? clickedRecord.id.split('_')[0] : '');
        var finalItemId = '';
        if (isBundle && shopifyProductId) {
            finalItemId = ('bundle_' + shopifyProductId).toLowerCase();
        } else {
            finalItemId = clickedRecord.sku ? clickedRecord.sku.toLowerCase().substring(0, 9) : '';
        }

        var klevuPrice = parseFloat(clickedRecord.price) || 0;
        var klevuSalePrice = parseFloat(clickedRecord.salePrice) || klevuPrice;
        var finalPrice = klevuSalePrice;
        var discount = klevuPrice - finalPrice;

        var item = {
            itemId: finalItemId,
            itemName: handle || clickedRecord.name,
            price: finalPrice,
            discount: discount > 0 ? discount : 0,
            itemListName: listName,
            itemListId: listId,
            sizesWithoutStock: undefined,
            index: clickedIndex,
            // Search results are never rendered inside a grid module, and the item is built
            // from the Klevu record rather than from a card, so the type is stated here
            // instead of read: the variable is required on every product.
            moduleType: 'standard',
            vendor: clickedRecord.brand ? clickedRecord.brand.toLowerCase() : '',
            product_type: undefined
        };

        var selectItemData = {
            item_list_id: listId,
            item_list_name: listName,
            items: [item]
        };

        if (localStorage.getItem('bobo_gtm_debug') === 'true') {
            console.log('[GTM Debug] selectItemData saved in localStorage:', selectItemData);
        }
        localStorage.setItem('bobo_gtm_pending_select_item', JSON.stringify(selectItemData));

        if (window.BoboDataLayer && typeof window.BoboDataLayer.setListContext === 'function') {
            // The module travels with the context too, so a product page reached from
            // search reports the same type its select_item did instead of nothing.
            window.BoboDataLayer.setListContext(item.itemId, listId, listName, clickedIndex, { moduleType: item.moduleType });
            if (localStorage.getItem('bobo_gtm_debug') === 'true') {
                console.log('[GTM Debug] Klevu setListContext key:', { itemId: item.itemId });
            }
        }
    });
})();
// --- END GTM TRACKING ---

klevu.afterTemplateRender("quick", function (data, scope) {
    scope.kScope.template.getHelpers().setKlevuQuickPopupTopPositionVariable();
    window.addEventListener("resize", scope.kScope.template.getHelpers().setKlevuQuickPopupTopPositionVariable());
    // Update cache with results from this render
    updateKlevuResultsCache(data.template.query);

    _klevuPopupOpen = true;
    var searchedTerm = (data.template.query.productList && data.template.query.productList.meta)
        ? (data.template.query.productList.meta.searchedTerm || '')
        : '';
    scheduleKlevuViewItemList(data.template.query, searchedTerm);
});

(function (klevu) {
    klevu.extend({
        productCarousel: {
            base: {
                initProductsSlider: function (kuCarousel) {
                    return; // we don't need carousel
                }
            }
        }
    });
})(klevu);
/* ============== QUICK SEARCH TEMPLATES =============== */
const klevuQuickTemplateTabResultsCustom = `
    <% 
        var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue(); 
        var hasAnyResultFound = false;
        helper.each(data.query,function(key,query) {
            if(query.tab == true) {
                if(helper.hasResults(data,query.id)) {
                    var results = data.query[query.id].meta.totalResultsFound;
                    if(results > 0){
                        hasAnyResultFound = true;
                    }
                }
            }
        });
    %>
    <div class="kuContainer">
        <% const totalResultsFound = Object.values(data.query).find(obj => obj && obj.id === "productList").meta.totalResultsFound %>
        <% if (totalResultsFound > 0 && !isCmsEnabled) { %>
            <div class="header-kuContainer-title">
                <span><%= helper.translate("Showing") %></span>
                <span><%= totalResultsFound %></span>
                <span><%= helper.translate("products") %></span>
            </div>
        <% } %>
    
        <div class="kuTabs" role="tablist" style="display:<%= isCmsEnabled && hasAnyResultFound ? 'block' : 'none'  %>">
            <% var selectedTab = false; %>
            <% helper.each(data.query,function(key,query){ %>
                <% if(query.tab == true) { %>
                    <% if(helper.hasResults(data,query.id)) { %>
                        <a target="_self" class="kuTab<% if(!selectedTab){ selectedTab = true; %> kuTabSelected<% } %>" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab">
                            <%=helper.translate(query.tabText,data.query[query.id].meta.totalResultsFound)%>
                        </a>
                    <% } else { %>
                        <a target="_self" class="kuTabDeactive" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab">
                            <%=helper.translate(query.tabText,0)%>
                        </a>
                    <% } %>
                <% } %>
            <% }); %>
        </div>
    </div>
`;

const klevuQuickTemplateFiltersCustom = 
    `<% if(data.query[dataLocal].filters.length > 0 ) { %>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a 
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                            <% if(filter.options.length > 5 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <button class="ku-showMore" data-class="showMore">+ <%=helper.translate("Show")%> (<%= filter.options.length - 5 %>) <%=helper.translate("more")%> </button>
                                    <button class="ku-showMore" data-class="showLess">- <%=helper.translate("Show Less")%> </button>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                	<div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        	<% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
  							<div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
  								<div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
  							</div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a 
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>
            
            <!-- <div class="kuFiltersFooter">
            	<a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  			</div> -->
            
            
        </div>
    <% } %>
`;

// ---------------------------------------------------------------------------
// RFM SEGMENT VISIBILITY FILTER
//
// Visibility rule (resolved server-side via NONE_OF groupCondition):
//   - Public products (no "rfm" field) → always visible.
//   - Restricted products → visible only if the user has at least one
//     of the product's rfm.
//
// NONE_OF excludes a product if it matches ANY condition:
//   C1 INCLUDE [restrictedSegments the user lacks] → has a segment user can't access
//   C2 EXCLUDE [userSegments]                      → does not have any user segment
//
// A product passes only if it matches NEITHER condition, which means:
//   - It has no restricted segments without user access (or no rfm at all), AND
//   - It has at least one of the user's segments (or no rfm field at all).
//
// Dependencies (set in theme.liquid before this file loads):
//   window.klevu_restricted_rfm_segments → Array of all restricted segment names
//   window.customer_rfm_segment          → Array of the current user's segments
//                                          (empty array for guests)
// ---------------------------------------------------------------------------

function getRFMConditions() {
    var restrictedSegments = (window.klevu_restricted_rfm_segments || []).map(function (s) {
        return s.trim();
    }).filter(Boolean);

    if (restrictedSegments.length === 0) {
        return null;
    }

    var userSegments = (window.customer_rfm_segment || []).map(function (s) {
        return s.trim();
    }).filter(Boolean);
    
    var segmentsUserLacks = restrictedSegments.filter(function (segment) {
        return userSegments.indexOf(segment) === -1;
    });
    
    if (segmentsUserLacks.length === 0) {
        return null;
    }
    var conditions = [
        {
            "key": "rfm",
            "valueOperator": "INCLUDE",
            "values": segmentsUserLacks
        }
    ];

    if (userSegments.length > 0) {
        conditions.push({
            "key": "rfm",
            "valueOperator": "EXCLUDE",
            "values": userSegments
        });
    }

    return conditions;
}

klevu.modifyRequest("all", function (data, scope) {    
    var conditions = getRFMConditions();
    if (!conditions) return;

    klevu.each(data.request.current.recordQueries, function (key, query) {
        klevu.setObjectPath(query, "settings.groupCondition", {
            "groupOperator": "NONE_OF",
            "conditions": conditions
        });
    });
});

// Client-side response filter for queries where groupCondition is ignored
// (e.g. recentViewedProductList which uses includeIds/topIds).
klevu.modifyResponse("quick", function (data, scope) {
    var restrictedSegments = (window.klevu_restricted_rfm_segments || []).map(function (s) {
        return s.trim();
    }).filter(Boolean);

    if (restrictedSegments.length === 0) return;

    var userSegments = (window.customer_rfm_segment || []).map(function (s) {
        return s.trim();
    }).filter(Boolean);

    klevu.each(data.template.query, function (queryId, queryData) {        
        if (queryId !== "recentViewedProductList") return;
        if (!queryData || !queryData.result) return;
        if (!Array.isArray(queryData.result)) return;

        queryData.result = queryData.result.filter(function (record) {
            if (!record.rfm) return true;

            // Parse rfm field — format: "[top, vip]"
            var productSegments = record.rfm.replace(/[\[\]]/g, "").split(",").map(function (s) {
                return s.trim();
            }).filter(Boolean);

            // Keep product if none of its segments are restricted
            var restrictedProductSegments = productSegments.filter(function (seg) {
                return restrictedSegments.indexOf(seg) !== -1;
            });
            if (restrictedProductSegments.length === 0) return true;

            // Product has restricted segments → user must match at least one
            return restrictedProductSegments.some(function (seg) {
                return userSegments.indexOf(seg) !== -1;
            });
        });
    });
    // Populate GTM results cache after RFM filtering so the delegated click listener
    // can resolve products from trending/recently-viewed sections on popup open.
    updateKlevuResultsCache(data.template.query);

    _klevuPopupOpen = true;
    var searchedTerm = (data.template.query.productList && data.template.query.productList.meta)
        ? (data.template.query.productList.meta.searchedTerm || '')
        : '';
    scheduleKlevuViewItemList(data.template.query, searchedTerm);
});
